<template>
  <div class="animated fadeIn">
    <!-- <cardView :data="cardData" /> -->

    <b-row>
      <b-col md="12">
        <b-card header="Checklist Analytics">
          <b-row>
            <b-col sm="12" lg="6">
              <b-row>
                <b-col sm="6">
                  <Callout variant="info">
                    <small class="text-muted"
                      >Pending for Validation(Site-wide)</small
                    >
                    <br />
                    <strong class="h4">{{ dashData[0].ForValidation }}</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px' }">
                      <!--<callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#20a8d8" width="80" height="30" />-->
                      <!-- <callout-chart-example
                        chartId="callout-chart-01"
                        :data="[35, 23, 56, 22, 97, 23, 64]"
                        variant="info"
                        width="80"
                        height="30"
                      /> -->
                      <img
                        src="../assets/img/animated/validate-rotate.gif"
                        style="float: right"
                      />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="danger">
                    <small class="text-muted"
                      >Your Created Checklist for Validation</small
                    >
                    <br />
                    <strong class="h4">{{
                      dashData[0].YourChecklistForValidation
                    }}</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px' }">
                      <!-- <callout-chart-example
                        chartId="callout-chart-02"
                        :data="[65, 59, 84, 84, 51, 55, 40]"
                        variant="danger"
                        width="80"
                        height="30"
                      /> -->
                      <img
                        src="../assets/img/animated/note-slide.gif"
                        style="float: right"
                      />
                    </div>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0" />
              <!-- <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Monday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress class="progress-xs" variant="info" :value="34" height="{}"/>
                  <b-progress class="progress-xs" variant="danger" :value="78" height="{}"/>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Tuesday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="56" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="94" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Wednesday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="12" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="67" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Thursday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="43" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="91" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Friday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="22" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="73" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Saturday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="53" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="82" variant="danger"></b-progress>
                </div>
              </div>
              <div class="progress-group mb-4">
                <div class="progress-group-prepend">
                  <span class="progress-group-text">Sunday</span>
                </div>
                <div class="progress-group-bars">
                  <b-progress height="{}" class="progress-xs" :value="9" variant="info"></b-progress>
                  <b-progress height="{}" class="progress-xs" :value="69" variant="danger"></b-progress>
                </div>
              </div>
              <div class="legend text-center">
                <small>
                  <sup>
                    <b-badge pill variant="info">&nbsp;</b-badge>
                  </sup>
                  New clients
                  &nbsp;&nbsp;
                  <sup>
                    <b-badge pill variant="danger">&nbsp;</b-badge>
                  </sup>
                  Recurring clients
                </small>
              </div> -->
            </b-col>
            <b-col sm="12" lg="6">
              <b-row>
                <b-col sm="6">
                  <Callout variant="warning">
                    <small class="text-muted"
                      >Your Checklist For Validation</small
                    >
                    <br />
                    <strong class="h4" >
                      {{ dashData[0].ChecklistValidation }}</strong
                    >
                    <div class="chart-wrapper" :style="{ top: '-10px' }">
                      <!-- <callout-chart-example
                        chartId="callout-chart-03"
                        :data="[35, 23, 56, 22, 97, 23, 64]"
                        variant="#f8cb00"
                        width="80"
                        height="30"
                      /> -->
                      <img
                        src="../assets/img/animated/checklist-breath.gif"
                        style="float: right"
                      />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="warning">
                    <small class="text-muted">Your Ongoing Checklist</small>
                    <br />
                    <strong class="h4">{{
                      dashData[0].OngoingCheckList
                    }}</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px' }">
                      <!-- <callout-chart-example
                        chartId="callout-chart-03"
                        :data="[35, 23, 56, 22, 97, 23, 64]"
                        variant="#f8cb00"
                        width="80"
                        height="30"
                      /> -->
                      <img
                        src="../assets/img/animated/checklist-breath.gif"
                        style="float: right"
                      />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="success">
                    <small class="text-muted">Today's Utilization</small>
                    <br />
                    <strong class="h4">{{ dashData[0].itsekvalidated }}</strong>
                    <div class="chart-wrapper" :style="{ top: '-10px' }">
                      <!-- <callout-chart-example
                        chartId="callout-chart-04"
                        :data="[65, 59, 84, 84, 51, 55, 40]"
                        variant="#4dbd74"
                        width="80"
                        height="30"
                      /> -->
                      <img
                        src="../assets/img/animated/website-fliphor.gif"
                        style="float: right"
                      />
                    </div>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0" />
              <!-- <ul class="horizontal-bars type-2">
                <div class="progress-group">
                  <div class="progress-group-header">
                    <i class="icon-user progress-group-icon"></i>
                    <span class="title">Male</span>
                    <span class="ml-auto font-weight-bold">43%</span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="43" variant="warning"></b-progress>
                  </div>
                </div>
                <div class="progress-group mb-5">
                  <div class="progress-group-header">
                    <i class="icon-user-female progress-group-icon"></i>
                    <span class="title">Female</span>
                    <span class="ml-auto font-weight-bold">37%</span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="37" variant="warning"></b-progress>
                  </div>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header">
                    <i class="icon-globe progress-group-icon"></i>
                    <span class="title">Organic Search</span>
                    <span class="ml-auto font-weight-bold">
                      191,235
                      <span class="text-muted small">(56%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="56" variant="success"></b-progress>
                  </div>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header">
                    <i class="icon-social-facebook progress-group-icon"></i>
                    <span class="title">Facebook</span>
                    <span class="ml-auto font-weight-bold">
                      51,223
                      <span class="text-muted small">(15%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="15" variant="success"></b-progress>
                  </div>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header">
                    <i class="icon-social-twitter progress-group-icon"></i>
                    <span class="title">Twitter</span>
                    <span class="ml-auto font-weight-bold">
                      37,564
                      <span class="text-muted small">(11%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="11" variant="success"></b-progress>
                  </div>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header">
                    <i class="icon-social-linkedin progress-group-icon"></i>
                    <span class="title">LinkedIn</span>
                    <span class="ml-auto font-weight-bold">
                      27,319
                      <span class="text-muted small">&nbsp;(8%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars">
                    <b-progress height="{}" class="progress-xs" :value="8" variant="success"></b-progress>
                  </div>
                </div>
                <div class="divider text-center">
                  <b-button variant="link" size="sm" class="text-muted">
                    <i class="icon-options"></i>
                  </b-button>
                </div>
              </ul> -->
            </b-col>
          </b-row>
          <br />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "../services/api";
import CardView from "./dashboard/MainDashboardCardView";
import CardLine1ChartExample from "./dashboard/CardLine1ChartExample";
import CardLine2ChartExample from "./dashboard/CardLine2ChartExample";
import CardLine3ChartExample from "./dashboard/CardLine3ChartExample";
import CardBarChartExample from "./dashboard/CardBarChartExample";
import MainChartExample from "./dashboard/MainChartExample";
import SocialBoxChartExample from "./dashboard/SocialBoxChartExample";
import CalloutChartExample from "./dashboard/CalloutChartExample";
import axios from "axios";
import { Callout } from "@coreui/vue";

export default {
  name: "dashboard",
  components: {
    cardView: CardView,
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
  },
  data: function () {
    return {
      selected: "Month",
      cardData: [],
      dashData: [],
    };
  },
  methods: {
    initDashboard: function () {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "/itsek/get-itsek-dashboard?department=" +
          this.$store.getters.selectedWarehouse +
          "&emplID=" +
          this.$store.getters.user.emplId
      );

      return (
        promise
          // axios.get("http://localhost:58426/api/itsek/get-itsek-dashboard?department=FSC01&emplID=18092475")
          .then((resp) => {
            self.$store.commit("setLoading", false);
            self.dashData = resp.data;
            console.log("dash", resp.data);
            // if(self.$store.state.dashboard == null) {
            // self.dashData = resp.data;

            // }
            // else {
            //   self.dashData = this.$store.state.dashboard
            // }

            // Here we could override the busy state, setting isBusy to false
            self.isBusy = false;

            //   return items;
          })
          .catch((error) => {
            // Here we could override the busy state, setting isBusy to false
            self.isBusy = false;
            self.$store.commit("setLoading", false);
            // Returning an empty array, allows table to correctly handle busy state in case
            // of error
            return [];
          })
      );
    },
    initTable: function () {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      let promise = api.instance.get(
        "/itsek/dashboard?brancode=" + this.$store.getters.selectedWarehouse
      );

      return (
        promise
          // axios
          //   .get("http://localhost:58426/api/itsek/dashboard?brancode=FSC01")
          .then((resp) => {
            self.$store.commit("setLoading", false);
            if (this.$store.state.dashboard.length == 0) {
              self.cardData = resp.data;
            } else {
              self.cardData = this.$store.state.dashboard;
            }

            // Here we could override the busy state, setting isBusy to false
            self.isBusy = false;

            //   return items;
          })
          .catch((error) => {
            // Here we could override the busy state, setting isBusy to false
            self.isBusy = false;
            self.$store.commit("setLoading", false);
            // Returning an empty array, allows table to correctly handle busy state in case
            // of error
            return [];
          })
      );
    },
    variant(value) {
      let $variant;
      if (value <= 25) {
        $variant = "info";
      } else if (value > 25 && value <= 50) {
        $variant = "success";
      } else if (value > 50 && value <= 75) {
        $variant = "warning";
      } else if (value > 75 && value <= 100) {
        $variant = "danger";
      }
      return $variant;
    },
    flag(value) {
      return "flag-icon flag-icon-" + value;
    },
  },
  created: function () {
    //this.initTable();
    this.initDashboard();
  },

  // watch: {
  //   dashData() {
  //     this.dashData = this.$store.state.dashboard;
  //   }
  // }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
